import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { validateField } from "../utils/signupValidation";

export const useSignupForm = (onSubmit, error, loading) => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    username: "",
    password: "",
    confirmPassword: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [localErrors, setLocalErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const validate = () => {
    const tempErrors = {};
    let valid = true;

    Object.keys(formData).forEach((field) => {
      const error = validateField(field, formData[field], formData);
      if (error) {
        tempErrors[field] = error;
        valid = false;
      }
    });

    setLocalErrors(tempErrors);
    return valid;
  };

  const handleChange = (field) => (e) => {
    const value = e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));

    setLocalErrors((prev) => {
      const newErr = { ...prev };
      delete newErr[field];
      return newErr;
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validate()) return;

    setLocalErrors({});
    setSuccessMessage("");

    const result = await onSubmit(formData);

    if (result?.success) {
      setSuccessMessage(result.message || "Account created successfully");

      setFormData({
        firstName: "",
        lastName: "",
        email: "",
        username: "",
        password: "",
        confirmPassword: "",
      });

      setTimeout(() => {
        navigate("/login", { replace: true });
      }, 2500);
    }
  };

  return {
    formData,
    showPassword,
    setShowPassword,
    showConfirmPassword,
    setShowConfirmPassword,
    localErrors,
    successMessage,
    error,
    loading,
    handleChange,
    handleSubmit,
  };
};
